import { Enumeration } from '@bp/shared/models/core/enum';

export class IdentityPreferencesPageTab extends Enumeration {

	static portal = new IdentityPreferencesPageTab();

}
